import { Button } from 'antd'

import { Modal, Trans } from '@/components'

interface MissingMetricModalProps {
  onOk: () => void
  onClose: () => void
}

export function MissingMetricModal(props: MissingMetricModalProps) {
  const { onOk, onClose } = props

  return (
    <Modal className="w-[480px]" open={true} onClose={onClose}>
      <Modal.Header>
        <Trans i18nKey="scaling.createSubPage.missingMetricModal.title">Missing Load Metric</Trans>
      </Modal.Header>
      <Modal.Body>
        <Trans i18nKey="scaling.createSubPage.missingMetricModal.content">
          At least one load metric is necessary to continue. Click Add Load Metric to include one.
        </Trans>
      </Modal.Body>
      <Modal.Footer>
        <Button size="large" className="h-11 px-4 py-3 t-sb" onClick={onClose}>
          <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
        </Button>
        <Button type="primary" size="large" className="h-11 px-4 py-3 t-sb" onClick={onOk}>
          <Trans i18nKey="scaling.createSubPage.missingMetricModal.confirmBtn">
            Add Load Metric
          </Trans>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
